<section class="challenge-block block-container" [style.color]="block.textColor" [class.has-pagination]="block?.contents?.length > 1">
  <h2 class="block-title" [innerHtml]="block.title | safeHtml" [rtl]="block.langcode"></h2>

  <lib-challenges-widget 
    [challenges]="block.contents"
    [textColor]="block.textColor"
    (joinChallenge)="joinChallenge($event)"
    (navigateToChallenge)="navigateToChallenge($event)">
  </lib-challenges-widget>

</section>
